(function () {
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this._url && this._url.includes('cart/add')) {
      this.addEventListener('load', function () {
        try {
          var response = JSON.parse(this.responseText);
          var cartItems = response.items || [response];

          cartItems.forEach(function (cartItem) {
            if (cartItem.properties && cartItem.properties._Size) return;

            var sizeValue = (cartItem.options_with_values || [])
              .filter(function (option) { return /size|band|cup/i.test(option.name); })
              .map(function (option) { return option.value; })
              .join('');

            if (!sizeValue) return;

            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: cartItem.key,
                quantity: cartItem.quantity,
                properties: Object.assign({}, cartItem.properties, { _Size: sizeValue })
              })
            });
          });
        } catch (e) {}
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
